import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
// lazyWidgetFactory.tsx
import React, { Suspense } from 'react';
import { widgetRegister } from './widgetRegister';
import { Loader2 } from 'lucide-react';
const lazyWidgetCache = {};
const getLazyComponent = (className) => {
    const loader = widgetRegister[className];
    if (!loader) {
        console.warn(`[B2C] Unknown widget className: ${className}`);
        return null;
    }
    if (!lazyWidgetCache[className]) {
        lazyWidgetCache[className] = React.lazy(loader);
    }
    return lazyWidgetCache[className];
};
export const renderLazyWidgetFromConfig = (config) => {
    const LazyComponent = getLazyComponent(config.className);
    if (!LazyComponent) {
        return (_jsxs("div", { style: { padding: '1rem', color: 'red' }, children: ["Unknown widget: ", config.className] }));
    }
    const style = config.style ?? {};
    return (_jsx(Suspense, { fallback: _jsx("div", { className: 'flex items-center justify-center min-h-screen', style: { padding: '1rem' }, children: _jsx(Loader2, { className: "size-8 stroke-1 animate-spin" }) }), children: _jsx("div", { "data-widget": config.className, children: _jsx(LazyComponent, { className: config.className, style: config.style, content: config.content }) }) }));
};
